import { FC, useMemo } from "react";
import cn from "classnames";

import "./skeleton-loader.scss";

interface ISkeleton {
  width?: number | string;
  height?: number | string;
  borderRadius?: number;
  maxWidth?: number;
}

const skeletonTheme = cn({
  "skeleton-loader-light": true,
});
const skeletonHeader = cn("skeleton_Header_upper", {
  "skeleton-loader-light": true,
});
const skeletonHeaderLower = cn("skeleton_Header_lower", {
  "skeleton-loader-light": true,
});
const SkeletonLogoTheme = cn("skeleton_logo", {
  "skeleton-loader-light": true,
});

export const Skeleton: FC<ISkeleton> = ({
  height,
  width,
  borderRadius = 0,
}) => {
  const { containerHeight, containerWidth } = useMemo(() => {
    const containerWidth = typeof width === "string" ? width : `${width}px`;
    const containerHeight = typeof height === "string" ? height : `${height}px`;

    return { containerWidth, containerHeight };
  }, [height, width]);

  return (
    <div
      className="skeleton_container"
      style={{ maxWidth: containerWidth, width: "100%" }}
    >
      <span
        className={skeletonTheme}
        style={{ height: containerHeight, borderRadius: `${borderRadius}px` }}
      />
    </div>
  );
};

export const SkeletonHeader = () => {
  return (
    <div className="skeleton_Header">
      <div className={skeletonHeader} />
      <div className={skeletonHeaderLower} />
    </div>
  );
};

export const SkeletonLogo = () => {
  return <div className={SkeletonLogoTheme} />;
};
